export class InspectorNameTransformer
{
  static convert( jsName:string )
  {
    let output = "";

    for ( let i = 0; i < jsName.length; i++ )
    {
      let character = jsName[ i ] + ""; 
      let upperCase = character.toUpperCase();
      let lowerCase = character.toLowerCase();
      
      if ( i === 0 )
      {
        output += upperCase;
        continue;
      }
      
      if ( upperCase !== lowerCase && upperCase === character )
      {
        output += " ";
      }
      
      output += character;
    }
    
    return output;
  }
}
